/**
 * Convenience function to loop through each element in a selector or array
 * @param {string, Array, NodeList, Element} elements The string selector, array, element
 *                                                    or nodelist to run against the document
 * @param callback The function to apply to each selected element
 */
export default function forEachElement(elements, callback) {
  if(!elements) return;
  if(typeof(elements) === 'string') elements = document.querySelectorAll(elements);
  if(elements instanceof Element) elements = [elements];
  [...elements].forEach(callback);
}
